var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react-hooks/rules-of-hooks */
// We can only import types here, otherwise we'll fail builds due to SSR
import React from "react";
import { setRiotBarAuthState } from "./riotBarHelper";
var EMPTY_AUTH_STATE = {
    rsoReady: false,
    user: undefined,
    session: undefined,
    login: function () { return void 0; },
    logout: function () { return void 0; },
    clearSession: function () { return void 0; },
    hookLoginFunctions: function () { return void 0; },
    rsoSession: undefined
};
var RSOContext = React.createContext(EMPTY_AUTH_STATE);
export var useRSOAuth = function () { return React.useContext(RSOContext); };
/**
 *
 * rsoAuth is a helper to deal with setting and retriving the idToken from rso-login.
 *
 * The hook tries to retrieve any existing token from cookies / storage,
 *
 *  */
export var RSOProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(EMPTY_AUTH_STATE), authState = _b[0], setAuthState = _b[1];
    var _c = React.useState(false), initialising = _c[0], setInitialising = _c[1];
    var _d = React.useState(false), rsoReady = _d[0], setRsoReady = _d[1];
    var _e = React.useState(), rsoInstance = _e[0], setRsoInstance = _e[1];
    var _f = React.useState(), rsoSession = _f[0], setRsoSession = _f[1];
    if (typeof window === "undefined") {
        return _jsx(RSOContext.Provider, __assign({ value: authState }, { children: children }), void 0);
    }
    // This is called inside the useEffect to protect against SSR for rso-login
    // useEffect ensures this is only called when this is "mounted" on the page.
    React.useEffect(function () {
        if (initialising) {
            return;
        }
        setInitialising(true);
        initRso();
    }, [initialising]);
    /**
     * This is the main entry point function for calling RSO.
     *
     * This is protected by an import statement because rso-login is not built for SSR.
     * This function should only be called where a browser context is availale (for example in a useEffect, or after a typeof browser check)
     */
    var initRso = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, RSO, FetchOptions, CallbackMode;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, import(/* webpackChunkName: 'rso' */ "@riotgames/rso-login")];
                case 1:
                    _a = _b.sent(), RSO = _a.RSO, FetchOptions = _a.FetchOptions, CallbackMode = _a.CallbackMode;
                    return [4 /*yield*/, RSO.init({
                            clientId: process.env.REACT_APP_RSO_CLIENT_ID,
                            rsoHost: process.env.REACT_APP_RSO_ROOT_URL,
                            callbackMode: CallbackMode.CODE_QUERY,
                            fetch: FetchOptions.TOKENS,
                            onReady: function (err, rso) {
                                setRsoInstance(rso);
                                console.log("RSO client ID: " + process.env.REACT_APP_RSO_CLIENT_ID);
                                if (err) {
                                    console.error("RSO.init error: " + err);
                                    return;
                                }
                                // We can only get the sesion in new login in /redirect page
                                var newSession = rso.getSession();
                                if (newSession.idToken && newSession.accessToken) {
                                    setRsoSession(newSession);
                                }
                                setRsoReady(true);
                            }
                        })];
                case 2:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Creates the login function to replace the default Riotbar login function
     */
    var login = React.useMemo(function () {
        var origin = new URL(window.location.href).origin;
        var redirectUri = origin + "/redirect/";
        var scope = ["account openid"];
        if (rsoInstance) {
            return function () { return __awaiter(void 0, void 0, void 0, function () {
                var CallbackMode;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, import(/* webpackChunkName: 'rso' */ "@riotgames/rso-login")];
                        case 1:
                            CallbackMode = (_a.sent()).CallbackMode;
                            rsoInstance.signIn({ scope: scope, redirectUri: redirectUri, callbackMode: CallbackMode.CODE_QUERY });
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, RSO, FetchOptions, CallbackMode;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'rso' */ "@riotgames/rso-login")];
                    case 1:
                        _a = _b.sent(), RSO = _a.RSO, FetchOptions = _a.FetchOptions, CallbackMode = _a.CallbackMode;
                        return [4 /*yield*/, RSO.init({
                                clientId: process.env.REACT_APP_RSO_CLIENT_ID,
                                rsoHost: process.env.REACT_APP_RSO_ROOT_URL,
                                callbackMode: CallbackMode.CODE_QUERY,
                                fetch: FetchOptions.NOTHING,
                                onReady: function (_err, rso) {
                                    rso.signIn({ scope: scope, redirectUri: redirectUri, callbackMode: CallbackMode.CODE_QUERY });
                                }
                            })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }, [rsoInstance]);
    /**
     * Creates a clear session function
     *
     * This should remove the auth state from the riotbar, as well as clearing any storage
     */
    var clearSession = React.useCallback(function () {
        localStorage.removeItem("shop_riotgames_rso_session");
        setRiotBarAuthState(false, "");
        /*
         * Page loaded, player is logged-in state
         * FE will hit `product_quote` endpoint
         * If API 401 error we are going to clear the session
         * We have to reset the session object to undefined as well
         * So that `useProductInfo` will hit `/product` endpoint
         */
        setRsoSession(undefined);
    }, []);
    /**
     * Creates the logout function to replace the default Riotbar logout function
     */
    var logout = React.useMemo(function () {
        var origin = new URL(window.location.href).origin;
        var redirectUri = origin + "/redirect/";
        var signOutOptions = { redirectUri: redirectUri };
        if (rsoInstance) {
            return function () {
                clearSession();
                rsoInstance.signOut(signOutOptions);
            };
        }
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, RSO, FetchOptions, CallbackMode;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'rso' */ "@riotgames/rso-login")];
                    case 1:
                        _a = _b.sent(), RSO = _a.RSO, FetchOptions = _a.FetchOptions, CallbackMode = _a.CallbackMode;
                        return [4 /*yield*/, RSO.init({
                                clientId: process.env.REACT_APP_RSO_CLIENT_ID,
                                rsoHost: process.env.REACT_APP_RSO_ROOT_URL,
                                callbackMode: CallbackMode.CODE_QUERY,
                                fetch: FetchOptions.NOTHING,
                                onReady: function (_err, rso) {
                                    clearSession();
                                    rso.signOut(signOutOptions);
                                }
                            })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }, [rsoInstance, clearSession]);
    /**
     * Hooks into the riotbar auth functions to use the library instead
     */
    var hookLoginFunctions = React.useMemo(function () {
        return function () {
            window.RiotBar.account.login = login;
            window.RiotBar.account.logout = logout;
        };
    }, [login, logout]);
    // Get any previously saved session
    var savedSession = React.useMemo(function () {
        if (!rsoReady) {
            return;
        }
        var currentSession = localStorage.getItem("shop_riotgames_rso_session");
        if (!currentSession) {
            return null;
        }
        try {
            // Check if the token is expired
            var parsedSession = JSON.parse(currentSession);
            var exp = JSON.parse(atob(parsedSession.accessToken.split(".")[1])).exp;
            // https://stackoverflow.com/a/51293316/1428241
            if (Date.now() >= exp * 1000) {
                // Removes session from localstorage
                clearSession();
                return null;
            }
            else {
                // Player's token is not expired
                return parsedSession;
            }
        }
        catch (e) {
            console.error("Unable to parse the saved session: " + e);
            return null;
        }
    }, [rsoReady, clearSession]);
    // Get the current session
    var session = React.useMemo(function () {
        // Player is logging-in first time && Works only on /redirect page
        if (!savedSession && rsoSession) {
            // Extract last pathname: https://stackoverflow.com/a/51795122/1428241
            var urlSegments = new URL(window.location.href).pathname.split("/");
            var urlLast = urlSegments.pop() || urlSegments.pop(); // Handle potential trailing slash
            if (urlLast === "redirect") {
                // Get whatever we need from the rsoSession
                var idToken = rsoSession.idToken, accessToken = rsoSession.accessToken;
                var rsoParsed = { idToken: idToken, accessToken: accessToken };
                localStorage.setItem("shop_riotgames_rso_session", JSON.stringify(rsoParsed));
                return rsoParsed;
            }
            else {
                console.error("Unable to get the token. rso.getSession()");
            }
        }
        // Player is already logged-in
        return savedSession;
    }, [rsoSession, savedSession]);
    // Parse player name, tag, and puuid from idToken
    var _g = React.useMemo(function () {
        if (!session) {
            return {};
        }
        try {
            // Parse the token
            // https://stackoverflow.com/a/46188039/1428241
            // eslint-disable-next-line prefer-const
            var _a = JSON.parse(atob(session.idToken.split(".")[1])), _b = _a.acct, _c = _b === void 0 ? {} : _b, _d = _c.game_name, game_name = _d === void 0 ? "" : _d, _e = _c.tag_line, tag_line = _e === void 0 ? "" : _e, _f = _a.sub, sub = _f === void 0 ? null : _f;
            // game_name can be null, no problemo! That is expeced and no need error handling here.
            return { gameName: game_name, tagLine: tag_line, puuid: sub };
        }
        catch (err) {
            console.error("idToken parsing error while extracting the game name: " + err);
            return {};
        }
    }, [session]), gameName = _g.gameName, tagLine = _g.tagLine;
    // Set Auth State
    React.useEffect(function () {
        // This simply ensure we only set the token once rso is ready
        if (!rsoReady) {
            return;
        }
        setAuthState({
            rsoReady: rsoReady,
            user: {
                gameName: gameName,
                tagLine: tagLine
            },
            session: session,
            login: login,
            logout: logout,
            clearSession: clearSession,
            hookLoginFunctions: hookLoginFunctions
        });
    }, [session, rsoReady, gameName, tagLine, clearSession, hookLoginFunctions, login, logout]);
    return _jsx(RSOContext.Provider, __assign({ value: authState }, { children: children }), void 0);
};
//# sourceMappingURL=rsoAuth.js.map